import { render, staticRenderFns } from "./disposalMainView.vue?vue&type=template&id=ac075d90&scoped=true"
import script from "./disposalMainView.vue?vue&type=script&lang=js"
export * from "./disposalMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac075d90",
  null
  
)

export default component.exports